// Investor Report Data - Tu Iglesia App Valuation

export const valuationSummary = {
  recommended: "USD 3.5M",
  range: "USD 3.5M – USD 5.5M",
  upside: "USD 7.5M+",
  previous: "USD 1.2M",
  revaluationMultiple: "2.9x",
  multipleOnInvestment: "4.0x",
  stage: "Pre-revenue con producto funcional",
  date: "2025"
};

export const currentSituation = [
  { label: "Etapa", value: "Pre-revenue con producto funcional" },
  { label: "Inversión Acumulada", value: "USD 865,000" },
  { label: "Valuación Previa", value: "USD 1.2M pre-money" },
  { label: "Valuación Recomendada", value: "USD 3.5M pre-money" },
  { label: "Runway", value: "10 meses" },
  { label: "Burn Mensual", value: "USD 18,000" },
  { label: "Mercado Inicial", value: "Venezuela" },
  { label: "Piloto Estratégico", value: "CCN (450 congregaciones, 120,000 miembros)" },
  { label: "Modelo de Ingresos", value: "SaaS + Pasarela de pagos" },
  { label: "ARPU Inicial Estimado", value: "USD 0.72 / usuario / mes" }
];

export const marketData = {
  tam: { value: "24,000", desc: "Congregaciones protestantes hispanas" },
  sam: { value: "24,000", desc: "Congregaciones potencialmente alcanzables" },
  som: { value: "7,000", desc: "Objetivo a 3 años" },
  idealClient: "Iglesias protestantes cristianas innovadoras con 150 a 800 miembros",
  globalMarket: [
    { source: "Strategic Market Research", value2024: "USD 1.2B", value2030: "USD 2.1B", cagr: "9.5%" },
    { source: "Technavio", increase: "USD 418.5M (2024-2029)", cagr: "8.9%" }
  ],
  expansion: ["Venezuela", "Colombia", "Mercado hispano en Estados Unidos"]
};

export const revenueModel = [
  { source: "Suscripción SaaS", perUser: "USD 0.25 / usuario / mes", description: "Por congregación, basado en miembros" },
  { source: "Comisión Pasarela de Pagos", perUser: "USD 0.47 / usuario / mes", description: "0.7% a 1.2% por país (base 1%)" }
];

export const projections = {
  ccnPilot: {
    members: "120,000",
    congregations: "450",
    avgPerCongregation: "267",
    subscriptionRate: "70%",
    gatewayActivation: "100%",
    mrrPotential: "USD 77,400",
    arrPotential: "USD 928,800"
  },
  year1: {
    congregations: "1,500",
    users: "400,000",
    mrr: "USD 288,000",
    arr: "USD 3,456,000"
  },
  year3: {
    congregations: "7,000",
    users: "1,867,000",
    mrr: "USD 1,344,000",
    arr: "USD 16,128,000"
  },
  breakeven: {
    fullArpu: "25,000 usuarios",
    conversionScenario: "27,907 usuarios"
  }
};

export const valuationMethods = [
  { method: "Cost-to-Duplicate", range: "USD 1.2M – USD 1.6M", usage: "Piso de valoración" },
  { method: "Berkus Adaptado", range: "USD 3.2M", usage: "Valoración primaria" },
  { method: "Scorecard Conservador", range: "USD 3.0M – USD 4.5M", usage: "Valoración primaria" },
  { method: "Risk Factor Summation", range: "USD 3.2M – USD 4.0M", usage: "Valoración primaria" },
  { method: "Venture Capital (Referencial)", range: "USD 3.5M – USD 5.5M", usage: "Referencial" }
];

export const berkusBreakdown = [
  { factor: "Idea / Concepto", value: "USD 500K" },
  { factor: "Producto Funcional", value: "USD 800K" },
  { factor: "Equipo", value: "USD 600K" },
  { factor: "Validación / Pilotos", value: "USD 500K" },
  { factor: "Propiedad Intelectual", value: "USD 400K" },
  { factor: "IA Pastoral", value: "USD 400K" }
];

export const valuationScenarios = [
  { scenario: "Conservador", valuation: "USD 3.5M", conditions: "Base actual sin ingresos" },
  { scenario: "Base Razonable", valuation: "USD 4.0M – USD 5.5M", conditions: "Con conversión de pilotos" },
  { scenario: "Upside Condicionado", valuation: "USD 7.5M+", conditions: "MRR estable + retención demostrada" }
];

export const capTable = [
  { stakeholder: "Socio A", percentage: "20%", implicitValue: "USD 700,000" },
  { stakeholder: "Socio B", percentage: "20%", implicitValue: "USD 700,000" },
  { stakeholder: "Socio C", percentage: "10%", implicitValue: "USD 350,000" },
  { stakeholder: "Socio D", percentage: "10%", implicitValue: "USD 350,000" },
  { stakeholder: "Socio E", percentage: "30%", implicitValue: "USD 1,050,000" },
  { stakeholder: "Fondo de Reserva", percentage: "10%", implicitValue: "USD 350,000" }
];

export const riskMatrix = [
  { risk: "Pre-revenue", impact: "Negativo", mitigation: "Conversión acelerada de pilotos a clientes pagos" },
  { risk: "Conversión Comercial", impact: "Negativo", mitigation: "Formalizar contratos con redes congregacionales" },
  { risk: "Infraestructura", impact: "Medio", mitigation: "Escalabilidad cloud y monitoreo de rendimiento" },
  { risk: "Percepción Denominacional", impact: "Medio", mitigation: "Posicionamiento no-denominacional y adaptabilidad cultural" },
  { risk: "IA Pastoral", impact: "Medio", mitigation: "Validación teológica y pruebas con líderes" }
];

export const milestones = [
  { timeline: "30 días", actions: ["Finalizar onboarding CCN", "Activar pasarela de pagos en piloto"] },
  { timeline: "60 días", actions: ["Primeros ingresos recurrentes (MRR)", "Medir retención y engagement"] },
  { timeline: "90 días", actions: ["Formalizar contratos con redes adicionales", "Iniciar expansión a Colombia"] },
  { timeline: "Q2 2026", actions: ["MRR estable demostrado", "Pipeline de nuevas congregaciones", "Potencial inicio de dividendos"] }
];

export const productModules = [
  { module: "Registro y Perfil", description: "Gestión de membresía y perfiles congregacionales" },
  { module: "Feed Congregacional", description: "Noticias, anuncios y actividades de la iglesia" },
  { module: "Directorio", description: "Base de datos de miembros y contactos" },
  { module: "Biblia Integrada", description: "Múltiples versiones con concordancias y búsqueda" },
  { module: "Devocionales", description: "Contenido diario de oración y reflexión" },
  { module: "Medios", description: "Videos, streaming en vivo, podcasts, alabanzas" },
  { module: "Eventos", description: "Calendario y gestión de actividades" },
  { module: "Comunidad", description: "Chats, grupos, mensajería interna" },
  { module: "Oración", description: "Peticiones y seguimiento de oración" },
  { module: "Donaciones", description: "Diezmos, ofrendas y pasarela de pagos" },
  { module: "Suite Ministerial", description: "Panel centralizado de administración" },
  { module: "Centro de Alabanzas", description: "Plataforma de música y adoración" },
  { module: "IA Pastoral", description: "Asistente de inteligencia artificial para soporte pastoral" }
];

export const teamInfo = {
  founders: [
    { name: "Jorge Méndez", role: "Co-Fundador" },
    { name: "Enrique Pernía", role: "Co-Fundador" }
  ],
  cto: { name: "Illich Ferrigno", role: "CTO" },
  teamSize: 19,
  holding: "Everlasting Love Group"
};

export const tractionSignals = [
  "Piloto CCN: 450 congregaciones, 120,000 miembros potenciales",
  "Iglesia Valientes: en fase de prueba activa",
  "Pipeline denominacional en desarrollo",
  "Territorio mapeado y segmentado",
  "Influencers y embajadores identificados",
  "Producto funcional con todos los módulos operativos"
];
